import { ClassType } from '@lingoda/graphql';
import { trans } from '@lingoda/i18n';
import { Divider, Stack } from '@lingoda/ui';
import { colorsPalette } from '@lingoda/ui/theme';
import { CreditsTag } from './CreditsTag';

interface Props {
    showZeroClasses?: boolean;
    groupCredits?: number;
    individualCredits?: number;
}

export const StudentCreditsContent = ({
    showZeroClasses: showZeroClassesProp,
    groupCredits = 0,
    individualCredits = 0,
}: Props) => {
    const showZeroClasses = showZeroClassesProp || (!groupCredits && !individualCredits);
    const showGroup = showZeroClasses || !!groupCredits;
    const showIndividual = showZeroClasses || !!individualCredits;

    return (
        <Stack
            direction="row"
            spacing={1.5}
            divider={
                <Divider
                    style={{ backgroundColor: colorsPalette.blackAlpha[20] }}
                    flexItem
                    orientation="vertical"
                />
            }
        >
            {showGroup && (
                <CreditsTag
                    type={ClassType.Group}
                    amount={groupCredits}
                    aria-label={`${groupCredits} ${trans(
                        'form-label-group-classes',
                        {},
                        'public-common',
                    )}`}
                />
            )}
            {showIndividual && (
                <CreditsTag
                    type={ClassType.Individual}
                    amount={individualCredits}
                    aria-label={`${individualCredits} ${trans(
                        'form-label-private-classes',
                        {},
                        'public-common',
                    )}`}
                />
            )}
        </Stack>
    );
};
